export default __webpack_public_path__ + "1cfc8d6fe4ff9ae6b0eb8d643cb38e58.png";